import React from "react";
import { SlateListPopover } from "./SlateListPopover";
import styles from "./SlateEditor.module.scss";

interface SlashCommand {
    id: string;
    description: string;
}

interface SlashCommandPopoverProps {
    isOpen: boolean;
    onClose: () => void;
    anchorRef: React.RefObject<HTMLSpanElement | null>;
    filteredCommands: SlashCommand[];
    slashIndex: number;
    setSlashIndex: (index: number) => void;
    selectSlashCommand: (commandId: string) => void;
}

export const SlashCommandPopover: React.FC<SlashCommandPopoverProps> = ({
    isOpen,
    onClose,
    anchorRef,
    filteredCommands,
    slashIndex,
    setSlashIndex,
    selectSlashCommand,
}) => (
    <SlateListPopover
        isOpen={isOpen}
        onClose={onClose}
        anchorRef={anchorRef}
        items={filteredCommands}
        getItemKey={(command) => command.id}
        activeIndex={slashIndex}
        setActiveIndex={setSlashIndex}
        onSelect={(command) => selectSlashCommand(command.id)}
        renderItem={(command) => (
            <>
                <span className={styles.slashCommandName}>/{command.id}</span>
                <span className={styles.slashCommandDescription}>
                    {command.description}
                </span>
            </>
        )}
    />
);
